import { useContext } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { InFieldLocationConfig } from '@cognite/apm-client';

import { useFDMServices } from '../../../../../providers/fdm-services/fdm-services.context';
import { MutationKeys, QueryKeys } from '../../../../../utils/queryKeys';

import { UseUpsertInfieldLocationConfigMutationContext } from './use-upsert-infield-location-config-mutation.context';

export const useUpsertInfieldLocationConfig = () => {
  const { captureException } = useContext(
    UseUpsertInfieldLocationConfigMutationContext
  );
  const { apmClient } = useFDMServices();
  const queryClient = useQueryClient();

  return useMutation<
    InFieldLocationConfig[] | undefined,
    Error,
    InFieldLocationConfig[]
  >({
    mutationFn: async (infieldLocationConfigToUpsert) => {
      const {
        data: { items: infieldLocationConfig },
      } = await apmClient.infieldLocationConfig.upsert(
        infieldLocationConfigToUpsert
      );
      return infieldLocationConfig;
    },
    onError: (err) => {
      captureException(err);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.INFIELD_LOCATION_CONFIG],
      });
    },
    mutationKey: [MutationKeys.USE_INFIELD_LOCATION_CONFIG_UPSERT],
  });
};
